import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
//api
import { api } from "../../utils/Api";
//toast
import toast from "react-hot-toast";
import DataContext from "../../utils/Context/DataContext";

import SignUpPage from "../SignUpPage.js/SignUpPage";

import CreateAccount from "../CreateAccount/CreateAccount";
import DisabledAccount from "../DisabledAccount/DisabledAccount";
import SuspendedAccount from "../SuspendedAccount/SuspendedAccount";

export default function Home(props) {
  const [active_data, SetActiveData] = useState("");
  const [account_disabled, SetAccountDisabled] = useState("");
  const [account_suspended, SetAccountSuspended] = useState("");
  const [account_logged_in, SetAccountLoggedIn] = useState("");

  const context = useContext(DataContext);

  useEffect(() => {
    console.log("Home On mount :", context);
    get_init();
  }, []);

  async function get_init() {
    let response = await api("/init");
    console.log("app_init :", response);
    SetActiveData(response.response.active_account);
    SetAccountDisabled(response.response.account_disabled);
    SetAccountSuspended(response.response.account_suspended);
    SetAccountLoggedIn(response.response.auth_loggedin);

    context.SetUserData(response.response.user_details);
    let active_account = response.response.active_account;

    if (
      active_account &&
      !response.response.hasOwnProperty("account_disabled")
    ) {
      window.location.href = "/dashboard";
    }
  }

  return (
    <>
      {active_data == false && account_disabled == true && <DisabledAccount />}

      {active_data == true && account_disabled == null && (
        <div>
          <p>Service Provider Home Page</p>
          <button>
            <Link to={"/create_account"}>Create Account</Link>
          </button>
          <button>
            <Link to={"/dashboard"}>Dashboard</Link>
          </button>
          <button
            onClick={() => {
              console.log("Toast Home");
              toast.success("Home Toast");
            }}
          >
            Toast
          </button>
        </div>
      )}

      {active_data == false &&
        account_disabled == null &&
        account_suspended == true && <SuspendedAccount />}

      {active_data == false &&
        account_disabled == null &&
        account_suspended == null &&
        account_logged_in == true && <CreateAccount />}

      {/* {active_data?(<div>
      <p>Service Provider Home Page</p>
      <button>
        <Link to={"/create_account"}>Create Account</Link>
      </button>
      <button>
        <Link to={"/dashboard"}>Dashboard</Link>
      </button>
      <button
        onClick={() => {
          console.log("Toast Home");
          toast.success("Home Toast");
        }}
      >
        Toast
      </button>
    </div>):(<SignUpPage/>)} */}
    </>
  );
}
